//This is the card that displays for every worker in thee worker's page for the profile User.
//When a button is clicked on the card, we set te selected worker in the redux store and navigate to the appropiate page.
//either the transactions page or the update worker page.
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setSelectedWorker } from '../features/selectedWorker/selectedWorkerSlice';
import { sendOnboardingReminder } from '../features/workers/workerSlice';
import { useState } from 'react';
import { sendCustomMsg } from '../actions/sendCustomMsg';

import { FaUserEdit, FaCalendar, FaCheckCircle, FaCommentDots } from 'react-icons/fa';

function WorkerItem({ worker }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const token = useSelector((state) => state.auth.user?.token);
    const [showMsgModal, setShowMsgModal] = useState(false);
    const [customMsg, setCustomMsg] = useState("");

    const handleViewTransactions = () => {
        const payload = {
            id: worker.id,
            name: worker.name,
            lastName: worker.lastName,
            profilePicture: worker.profilePicture,
            rate: worker.rate,
        };

    

        dispatch(setSelectedWorker(payload));
        navigate('/worker/attendance');
    };

    const handleSendReminder = () => {
        dispatch(sendOnboardingReminder(worker.id));
    };

    const handleOpenMsgModal = () => {
        setShowMsgModal(true);
        setCustomMsg("");
    };
    const handleCloseMsgModal = () => {
        setShowMsgModal(false);
    };
    const handleMsgChange = (e) => {
        setCustomMsg(e.target.value);
    };
    const handleSendMsg = async () => {
        const fullMsg = `Hello, ${worker.name}, ${customMsg}\n\nThis is an automated message, do not reply.`;
        try {
            await sendCustomMsg(token, worker.phone, fullMsg);
        } catch (error) {
            // Optionally show error to user
        }
        setShowMsgModal(false);
    };

  
    return (
        <div className='flex flex-wrap justify-center'>
            <div className='m-4 p-4 bg-sage rounded-lg shadow-lg w-full max-w-md'>
                <div className='flex justify-center items-center'>
                    <img 
                        src={worker.profilePicture ? worker.profilePicture : '/workerSilhoutte.png'} 
                        alt="workerImage" 
                        className="w-24 h-24 object-cover rounded-full border-4 border-teal"
                    />
                </div>
                
                <div className='p-1'>
                    
                   <div className='text-center'>
                        <h1 className='text-xl font-semibold my-1 px-4 capitalize rounded text-charcoal'>
                            {worker.name}
                        </h1>
                        <h1 className='text-xl font-semibold my-1 px-4 capitalize rounded text-charcoal'>
                            {worker.lastName}
                        </h1>
                   </div>
                   <div className='mt-4 text-center'>
                        {worker.onboarded === true ? (
                            <div className='flex justify-center'>
                                <FaCheckCircle className='text-green-500 text-2xl' />
                            </div>
                        ) : (
                            <div className='mt-4'>
                                <button
                                    className='bg-robin text-teal px-4 py-2 rounded font-semibold hover:bg-teal hover:text-robin transition'
                                    onClick={handleSendReminder}
                                >
                                    Send Reminder
                                </button>
                            </div>
                        )}
                        <div className='text-charcoal text-sm font-mono'>
                            <p>{worker.role}</p>
                            <p>{`${worker.phone.slice(0, 3)}-${worker.phone.slice(3, 6)}-${worker.phone.slice(6)}`}</p>
                            <p>Hourly rate: <span className='font-bold'>${worker.rate}</span></p>
                        </div>
                      
                       
                    </div>

                    
                </div>
                
                <div className='p-2 mt-1 flex justify-between items-center'>
                    <button 
                        className='text-2xl text-teal hover:text-robin transition' 
                        onClick={handleViewTransactions}
                    >
                        <FaCalendar />
                    </button>

                    <button 
                        className='text-2xl text-teal hover:text-robin transition'
                        onClick={handleOpenMsgModal}
                    >
                        <FaCommentDots />
                    </button>

                    <Link to={`/workers/update`} state={{ currentWorkerData: worker }} className='text-2xl text-teal hover:text-robin transition'>
                        <FaUserEdit />
                    </Link>
                </div>
                {/* Modal for custom message */}
                {showMsgModal && (
                    <div className="fixed inset-0 z-30 flex items-center justify-center bg-black bg-opacity-60">
                        <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
                            <h2 className="text-lg font-bold mb-2">Send Message to {worker.name}</h2>
                            <textarea
                                className="w-full h-32 border border-gray-300 rounded p-2 mb-4"
                                value={customMsg}
                                onChange={handleMsgChange}
                                placeholder="Type your message here..."
                            />
                            <div className="text-sm text-gray-500 mb-2">
                                <span className="font-bold">Message preview:</span>
                                <div className="mt-2 p-2 bg-gray-100 rounded">
                                    Hello, {worker.name}, {customMsg}<br/><br/>This is an automated message, do not reply.
                                </div>
                            </div>
                            <div className="flex justify-end gap-2">
                                <button className="px-4 py-2 bg-gray-300 rounded" onClick={handleCloseMsgModal}>Cancel</button>
                                <button className="px-4 py-2 bg-teal text-white rounded" onClick={handleSendMsg}>Send</button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default WorkerItem;